"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEDULE_ROUTES = exports.POSTING_SLOTS_PER_SCHEDULE_MAX = exports.SCHEDULING_CATEGORIES_MAX = exports.SCHEDULING_CATEGORY_NAME_MAX = exports.SCHEDULING_CATEGORY_COLOR_NAMES = exports.SCHEDULING_CATEGORY_COLORS = void 0;
/**
 * The scheduling-category palette, in the spec's order: orange, teal, purple, pink, blue, green, amber,
 * red, slate, brown. Content colours, not UI chrome: the web applies them by inline style, never as
 * classes. They live here, not in apps/web/src, so the API validates a category's colour against the same
 * list, and apps/web/src/colorTokens.gate.test.ts (which scans apps/web/src only) never sees a hex.
 */
exports.SCHEDULING_CATEGORY_COLORS = [
    '#F08A24',
    '#1A9BB8',
    '#7C5CE0',
    '#E0558F',
    '#3B6FE0',
    '#2FA66A',
    '#D6A100',
    '#E5484D',
    '#64748B',
    '#A0693A',
];
/** Each palette colour's accessible name (the swatch picker's labels), in the same order. */
exports.SCHEDULING_CATEGORY_COLOR_NAMES = [
    'Orange',
    'Teal',
    'Purple',
    'Pink',
    'Blue',
    'Green',
    'Amber',
    'Red',
    'Slate',
    'Brown',
];
/** A category name is trimmed, then 1 to this many characters, unique in its workspace ignoring case. */
exports.SCHEDULING_CATEGORY_NAME_MAX = 30;
/** Categories per workspace. Keeps "save every schedule in one request" bounded. */
exports.SCHEDULING_CATEGORIES_MAX = 100;
/** Posting times per schedule (General, and each category on its own). */
exports.POSTING_SLOTS_PER_SCHEDULE_MAX = 200;
/**
 * Which "When to post" route chose a post's time — stored on the post (Prisma enum `ScheduleRoute`).
 *
 * A record of the DECISION, not of the outcome: NEXT, PRIORITIZE and MONTH all end in a queued time
 * and are indistinguishable afterwards, which is why the route has to be kept rather than inferred.
 */
exports.SCHEDULE_ROUTES = ['NEXT', 'PRIORITIZE', 'MONTH', 'EXACT'];
//# sourceMappingURL=scheduling.js.map